import Vue from 'vue';


export default function registerShortcuts (store) {
  Vue.prototype.$canUser = function (permission) {
    return store.getters['user/canUser'](permission);
  };

  Vue.prototype.$userIsAdmin = function () {
    return store.getters['user/currentUser'] && store.getters['user/currentUserIsAdmin'];
  };
}
